import type { DataCountry } from 'common/dataService/types/countriesTypes';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import FetchingStatus from 'constants/statuses/FetchingStatus';

export type DataCountriesState = {
  fetching: FetchingStatus | null;
  value: DataCountry[] | [];
};

const initialState: DataCountriesState = {
  fetching: null,
  value: [],
};

function setFetchingFunction(state: DataCountriesState, action: PayloadAction<DataCountriesState['fetching']>) {
  return {
    ...state,
    fetching: action.payload,
  };
}

function setDataCountriesFunction(state: DataCountriesState, action: PayloadAction<DataCountriesState['value']>) {
  return {
    ...state,
    value: action.payload,
  };
}

const slice = createSlice({
  name: 'dataService.dataCountries',
  initialState,
  reducers: {
    setFetching: setFetchingFunction,
    setDataCountries: setDataCountriesFunction,
  },
});

export const { setFetching, setDataCountries } = slice.actions;
export default slice.reducer;
